import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Target } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide3Challenge({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-155">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-156">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-157">
          The Challenge
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl" data-id="element-158">
          Most websites are{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-159">passive.</span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-[clamp(1.5rem,3vw,3rem)] min-h-0" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        x: -24
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="col-span-6 flex flex-col justify-center gap-6" data-id="element-161">
          <p className="text-[var(--fg)] text-[clamp(1.1rem,1.5vw,1.5rem)] font-medium leading-relaxed" data-id="element-162">
            Most websites often function as a passive, objection-handling
            destination.
          </p>
          <div className="bg-[var(--surface)] border border-black/5 rounded-2xl p-6 mt-2 relative overflow-hidden" data-id="element-163">
            <div className="absolute right-0 top-0 bottom-0 w-1/2 opacity-30 pointer-events-none flex items-center justify-end pr-4" data-id="element-164">
              <img src="https://cdn.magicpatterns.com/uploads/37LE1mVzrq32BLKLft6MP6/Screenshot_2026-06-29_at_10.13.04.png" alt="Eczema" className="h-full object-contain mix-blend-multiply" data-id="element-165" />
            </div>
            <p className="text-[var(--brand-green)] font-bold text-lg mb-2 flex items-center gap-2 relative z-10" data-id="element-166">
              <AlertCircle className="w-5 h-5" data-id="element-167" /> The High-Friction Journey
            </p>
            <p className="text-[var(--fg)] font-medium relative z-10 max-w-[70%]" data-id="element-168">
              For an HCP to engage with DermaWorld Anzupgo pages today, they
              must self-navigate a complex path.
            </p>
          </div>
          <p className="text-[var(--muted)] text-[clamp(1rem,1.2vw,1.2rem)] leading-relaxed" data-id="element-169">
            Most websites are often most useful once the HCP already knows they
            have a problem, is actively seeking a solution, and is ready to
            explore product information. But many HCPs are not there yet.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 24
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} className="col-span-6 flex flex-col gap-4 justify-center" data-id="element-170">
          <div className="bg-white border border-black/5 rounded-2xl p-8 shadow-sm relative overflow-hidden" data-id="element-171">
            <div className="absolute top-0 left-0 w-1.5 h-full bg-[var(--brand-green)]" data-id="element-172" />
            <h3 className="text-xl font-bold mb-6 text-[var(--fg)]" data-id="element-173">
              An HCP normally has to:
            </h3>
            <ul className="space-y-4 relative z-10" data-id="element-174">
              {['Recognize that they have a relevant clinical problem', 'Decide to actively seek a solution', 'Know or suspect that LEO may have a relevant answer', 'Visit the website', 'Navigate to the right section', 'Spend time interpreting the product information', 'Decide what to do next'].map((step, i) => <li key={i} className="flex items-center gap-3 text-[var(--muted)] font-medium" data-id="element-175">
                  <span className="w-6 h-6 rounded-full bg-[var(--brand-green)]/10 flex items-center justify-center text-xs font-bold text-[var(--brand-green)] flex-shrink-0" data-id="element-176">
                    {i + 1}
                  </span>
                  {step}
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-black/5" data-id="element-177">
              <p className="text-[var(--brand-green)] font-bold text-lg flex items-center gap-2" data-id="element-178">
                <Target className="w-5 h-5" data-id="element-179" /> They need relevance before they
                need detail.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}